import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { UserAuth } from '../../middleware/UserContext/UserContext.middleware';

interface PrivateRouteProps {
  children: ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { currentUser } = UserAuth();
  return currentUser ? <>{children}</> : <Navigate to="/login" />;
};

export default PrivateRoute;
